import { TaskLinkType } from '@models/tasks/task-link';
import { BaseTaskAction, TaskActionType } from './_base-task-action';
import { Guid, RecursivePartial } from '@models/base';
import { TaskLinkTask } from '../task-link-task';

export class TaskActionLinkAdd extends BaseTaskAction {
    type: TaskActionType.LinkAdd = TaskActionType.LinkAdd;

    linkType?: TaskLinkType;
    taskFromId?: Guid;
    taskToId?: Guid;
    taskFrom?: TaskLinkTask;
    taskTo?: TaskLinkTask;

    constructor(json?: RecursivePartial<TaskActionLinkAdd>) {
        super(json);
        this.parseTaskActionLinkAdd(json || {});
    }

    parse(json: RecursivePartial<TaskActionLinkAdd>): TaskActionLinkAdd {
        super.parse(json);
        this.parseTaskActionLinkAdd(json);
        return this;
    }

    private parseTaskActionLinkAdd(json: RecursivePartial<TaskActionLinkAdd>): void {
        TaskActionLinkAdd.assignFields<TaskActionLinkAdd>(this, json, ['linkType', 'taskFromId', 'taskToId']);
        TaskActionLinkAdd.assignClassFields(this, json, { taskFrom: TaskLinkTask, taskTo: TaskLinkTask });
    }
}
